import { useMemo } from "react";
import { useTheme } from "@mui/material/styles";
import type { MRT_RowData, MRT_TableOptions } from "material-react-table";
import { getSeeditMrtTableOptions } from "./mrt-table-theme";

/** Hook: shared Material React Table options for Seedit (spread into `useMaterialReactTable`). */
export function useSeeditMrtTableOptions<TData extends MRT_RowData>(): Partial<
  MRT_TableOptions<TData>
> {
  const theme = useTheme();
  return useMemo(() => getSeeditMrtTableOptions<TData>(theme), [theme]);
}
